<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<span class="token-picker-field-box" *ngIf="!isDynamic else dynamic">
  <mat-form-field *ngIf="showTokenTextBox" title="{{lf_field_info.displayName}}" appearance="outline"
    class="lf-field lf-date-field">
    <input #tokenTarget matInput [formControl]="lf_field_form_control" title="{{lf_field_form_control.value}}"
      (change)="onDateOrTimeTokenValueChanged()">
  </mat-form-field>

  <lf-uni-date-time #tokenTarget class="lf-field" *ngIf="!showTokenTextBox" [config]="uniDateTimeConfig"
    [settings]="uniDateTimeSettings" (valueChangedEventHandler)="onUniDateOrTimeChanged($event)">
  </lf-uni-date-time>
  <lf-token-picker-component class="lf-field-token-picker" (tokenPicked)="onTokenChosen($event)"
    [data]="lfFieldTokenData"></lf-token-picker-component>
</span>
<mat-error *ngIf="getBrokenValidationRule()">{{fieldValidationErrorMsg | async}}</mat-error>


<ng-template #dynamic>
  <lf-dynamic-field-component ngDefaultControl [options]="dynamic_field_value_options"
    [formControl]="lf_field_form_control" [title]="lf_field_info.displayName"
    [fieldValidationErrorMsg]="fieldValidationErrorMsg" [getBrokenValidationRule]="getBrokenValidationRule.bind(this)"
    (valueChange)="onValueChanged()" [compareWith]="compareDateStrings">
  </lf-dynamic-field-component>
</ng-template>
